export default __webpack_public_path__ + "static/media/certified.a9a8cd73.png";